<tag-selector [disabled]="disabled" [borderless]="borderless" [selectedTags]="tags" [uiId]="uiId" (tagAdd)="addTag($event)" (tagRemove)="removeTag($event)"></tag-selector>
